import React from "react";
import SDBG from "../../assets/Farm/omo.jpg";
import P7 from "../../assets/Farm/WhatsApp Image 2025-03-31 at 23.28.36_24fa7ab9.jpg";
import P8 from "../../assets/Ohaji-Farm/5.jpg";
import P1 from "../../assets/Ohaji-Farm/1.jpg";
import P2 from "../../assets/Ohaji-Farm/nice.jpg";
import P9 from "../../assets/Ohaji-Farm/2.jpg";
import P5 from "../../assets/Ohaji-Farm/3.jpg";
import P6 from "../../assets/Irrigation-System/Irrigation System - 7.jpg";
import P10 from "../../assets/Ohaji-Farm/8.jpg";
import P21 from "../../assets/Ohaji-Farm/10.jpg";
import P22 from "../../assets/Ohaji-Farm/4.jpg";
import P11 from "../../assets/Ohaji-Farm/7.jpg";
import IrrigationImg2 from "../../assets/Soil-Sampling/Soil Sampling - 2.jpg";
import VineCuttingImg2 from "../../assets/Soil-Sampling/Soil Sampling - 16.jpg";
import IrrigationImg3 from "../../assets/Vine-Cutting- Planting/Vine Cutting and Planting - 8.jpg";
import VineCuttingImg from "../../assets/Vine-Cutting- Planting/7.jpg"; 
import IrrigationImg from "../../assets/Irrigation-System/Learning about Drip Irrigation - 1.jpg"; 
import TextFade from "../../components/CustomTexts/TextFade";
import ScrollDown from "../../assets/scrollDown.svg";
import CallToActionSection from "../../components/Others/CallToActionSection";
import TextEffect from "../../components/CustomTexts/TextEffect";

const FarmingPage = () => {
  const images = [ P1, P2, P5, P21, P22, P8, P9, P10, P11];

  return (
    <div>
      {/* HERO SECTION */}
      <div
        className="flex-col h-[100vh] w-[100%] items-center justify-center bg-no-repeat bg-cover bg-center transition-all duration-1000 ease-in-out bg-dark relative"
        style={{
          backgroundImage: `url('${SDBG}')`,
        }}
      >
        <div className="absolute inset-0 bg-green-400/40 z-0" />
        <div className="h-full w-full flex px-[5%] flex-col gap-10 items-start justify-center z-10">
          <TextFade animation="fade-up">
            <h1 className="md:text-[60px] text-[30px] font-bold text-white transition-all duration-1000 ease-in-out ">
              <TextEffect part1="Farm" /> <TextEffect text1="Services" />
            </h1>
          </TextFade>
          <p className="text-light md:text-[20px] text-[14px] md:w-[45%] w-full">
            At Simdozi International Limited, we are more than just an agriculture company—we are a movement for sustainable nourishment, economic empowerment, and food security.
          </p>
        </div>
        <div className="flex items-center flex-col justify-center w-full h-fit gap-2 absolute bottom-10 z-10">
          <img src={ScrollDown} alt="" />
          <p className="text-light text-center text-[14px] italic">Scroll Down</p>
        </div>
      </div>

      {/* SERVICES SECTION */}
      <div className="flex md:flex-row flex-col border py-44 px-[5%] justify-between bg-light gap-10">
        {/* LEFT CONTENT */}
        <div className="md:w-1/2 w-full flex flex-col gap-20">
          {/* Vine Cutting */}
          <div className="h-full w-full flex flex-col gap-10 items-start justify-center">
            <TextFade animation="fade-up">
              <h1 className="md:text-[60px] text-[30px] font-bold text-dark transition-all duration-1000 ease-in-out ">
                Vine Cutting & Planting
              </h1>
            </TextFade>
            <p className="text-dark md:text-[20px] text-[14px]">
              Access premium quality, disease-free vines sourced from trusted nurseries. We offer a wide selection tailored to your region and farming goals. Our team will help you choose the right varieties and ensure timely delivery for seamless planting.
            </p>
          </div>

          {/* Image on mobile view */}
          <div className="md:hidden flex flex-col gap-8">
            <img
              src={VineCuttingImg}
              alt="Vine Cutting"
              className="h-[250px] w-full object-cover rounded-lg shadow-md"
            />
          </div>

          {/* Irrigation System */}
          <div className="h-full w-full flex flex-col gap-10 items-start justify-center">
            <TextFade animation="fade-up">
              <h1 className="md:text-[60px] text-[30px] font-bold text-dark transition-all duration-1000 ease-in-out ">
              Uke, Nasarawa Farm
              </h1>
            </TextFade>
            <p className="text-dark md:text-[20px] text-[14px]">
              We have been producing in our farm located at Kilometre 21, Keffi – Abuja Express Way, Uke, Karu Local Government Area of Nasarawa State since 2021.  This is a fenced facility enclosing livestock and crop farming groups. It therefore allows us to explore all aspects of smart farming using organic manure  climate resilience technologies.  We recently installed drip irrigation infrastructure here to enable us produce both vines and fresh tubers all year round. The farm is now a hub of activities as people come here to learn about best agronomic practices.
            </p>
            <br/>
            <p className="text-dark md:text-[20px] text-[14px]">
              Uke Farm is a state-of-the-art facility dedicated to the cultivation of Orange Fleshed Sweet Potatoes (OFSP). Our farm is equipped with advanced irrigation systems, soil sampling techniques, and expert agronomic practices to ensure optimal growth and yield. We are committed to sustainable farming practices that prioritize environmental stewardship and community well-being.
            </p>
          </div>

          {/* Image on mobile view */}
          <div className="md:hidden flex flex-col gap-8">
            <img
              src={IrrigationImg}
              alt="Irrigation System"
              className="h-[250px] w-full object-cover rounded-lg shadow-md"
            />
          </div>
        </div>

        {/* RIGHT IMAGES - DESKTOP ONLY */}
        <div className="md:w-1/2 w-full hidden md:grid grid-cols-2 gap-6 items-start justify-center">
          {[VineCuttingImg, IrrigationImg, VineCuttingImg2, IrrigationImg2, IrrigationImg3, P6, P7, VineCuttingImg2].map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Uke Farm ${idx}`}
              className="h-[250px] w-full object-cover rounded-lg shadow-lg hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out"
            />
          ))}
        </div>
      </div>

      {/* FARM ESTABLISHMENT SECTION */}
      <div className="bg-dark py-40 px-[5%] ">
        <div className="h-full w-full flex flex-col gap-10 items-start justify-center">
          <TextFade animation="fade-up">
            <h1 className="md:text-[60px] text-[30px] font-bold text-light transition-all duration-1000 ease-in-out ">
              Ohaji Farm Establishment, Soil Sampling & Setup Services
            </h1>
          </TextFade>
           
          <p className="text-light md:text-[20px] text-[14px] md:w-[95%] w-full">
            In 2021, we set up an Orange Fleshed Sweet Potato farm in Awara Ohaji in Ohaji Egbema Local Government Area of Imo State. It was our effort in introducing this wonderful food crop to the local communities in Imo State.  It was used to raise new farmers and increase awareness and utilization of OFSP in the Local Government Area. True to the objective, the farm officer then Mr. Alihie, Justice Chika is now a good representative of the OFSP Value Chain in Imo State.
          </p>
        </div>

        {/* IMAGE GRID */}
        <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-28 my-28">
          {images.map((item, index) => (
            <img
              src={item}
              alt={`Gallery ${index}`}
              key={index}
              className="h-[306px] w-[407px] object-cover rounded-md shadow-md"
            />
          ))}
        </div>
      </div>

      <CallToActionSection />
    </div>
  );
};

export default FarmingPage;
